export const CurrentEducatorMapper = (educator) => {
  if (!educator) {
    return null;
  }

  const { id, ...rest } = educator;
  return { ...rest, id: id };
};
